import { BrandPromiseProps, CardWrapperProps } from '../types';

export default function CardWrapper({
  className = '',
  children,
  backgroundStyles,
  ...props
}: React.PropsWithChildren<CardWrapperProps & BrandPromiseProps>) {

  const { deliveryOptionsBackgroundImageSrc,deliveryOptionsBackgroundImageAlt, deliveryOptionsBackgroundColor } = props;
  return (
    <div
      data-testid="service-card"
      aria-label={backgroundStyles ? deliveryOptionsBackgroundImageAlt : '' }
      style={{ background: backgroundStyles ? `url(${deliveryOptionsBackgroundImageSrc})` : deliveryOptionsBackgroundColor }}
      className={`${className} flex w-full flex-col items-center justify-start gap-12 rounded-2xl p-24 text-center lg:p-32`}
    >
      {children}

    </div>
  );
}
